import { connect } from 'react-redux'
import InterviewSchedule from 'modules/Report/Partials/InterviewSchedule/index.js'
import {
  cityDetails,
  tierDetails,
  collegeDetails,
  roleDetails,
  getApplicationDriveLevel,
  roundDetails,
  courseTypeDetails,
  degreeDetails,
  interviewDetails,
  studentDetails,
} from 'modules/Report/action.js'
import reportSelectors from 'modules/Report/selectors.js'
import authSelector from 'modules/Auth/selectors'
const mapStateToProps = state => ({
  cityData: reportSelectors.getCityData(state),
  tierData: reportSelectors.getTierData(state),
  collegeData: reportSelectors.getCollegeData(state),
  roleData: reportSelectors.getRoleData(state),
  roundData: reportSelectors.getRoundData(state),
  degreeData: reportSelectors.getDegreeData(state),
  courseTypeData: reportSelectors.getCourseTypeData(state),
  rolesPublishedData: reportSelectors.getInterviewData(state),
  excelDataForReport: reportSelectors?.excelData(state),
  getResumeData: reportSelectors?.getResumeData(state),
  corporateData: authSelector.getCorporateData(state),
})

const mapDispatchToProps = {
  cityDetails,
  tierDetails,
  getApplicationDriveLevel,
  collegeDetails,
  roleDetails,
  roundDetails,
  courseTypeDetails,
  degreeDetails,
  interviewDetails,
  studentDetails,
}
export default connect(mapStateToProps, mapDispatchToProps)(InterviewSchedule)
